import AudiosRoutes from '../modules/audios/_routes'
import GruposRoutes from '../modules/grupos/captura/_routes'
import GruposRamaisRoutes from '../modules/grupos/ramais/_routes'
import ramaisRoutes from '../modules/ramais/_routes'
import TroncosRoutes from '../modules/troncos/_routes'
import UrasRoutes from '../modules/uras/_routes'
import CentroDeCustoRoutes from '../modules/centroDeCusto/_routes'
import MusicaEmEsperaRoutes from '../modules/musicaEmEspera/_routes'
import AliasRegexRoutes from '../modules/regex/_routes'
import ConferenciaRoutes from '../modules/conferencia/_routes'
import TagRoutes from '../modules/TAG/_routes'

const CadastroHome = () => import(/* webpackChunkName: "group-pabx-cadastros" */ '../views/cadastrosHome')

import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'cadastro',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: CadastroHome,
    children: [
      ...AudiosRoutes,
      ...GruposRoutes,
      ...ramaisRoutes,
      ...TroncosRoutes,
      ...UrasRoutes,
      ...CentroDeCustoRoutes,
      ...GruposRamaisRoutes,
      ...MusicaEmEsperaRoutes,
      ...AliasRegexRoutes,
      ...ConferenciaRoutes,
      ...TagRoutes,
    ],
  },
]
